import { Fragment } from 'react';

import styles from './HeatmapChart.module.css';

interface HeatmapChartProps {
    // heatmap[row][col] = count
    heatmap: Record<string, Record<string, number>>;
    rows: string[];
    columns: string[];
    total?: number;
}

export function HeatmapChart({ heatmap, rows, columns, total }: HeatmapChartProps) {
    if (rows.length === 0 || columns.length === 0) {
        return <p className={styles.empty}>Sin datos</p>;
    }

    // Find max value for normalization
    let maxVal = 0;
    rows.forEach((row) => {
        columns.forEach((col) => {
            const v = heatmap[row]?.[col] ?? 0;
            if (v > maxVal) maxVal = v;
        });
    });

    const totalCount = total ?? maxVal;

    return (
        <div className={styles.wrapper}>
            <div
                className={styles.grid}
                style={{
                    gridTemplateColumns: `minmax(80px, auto) repeat(${columns.length}, 1fr)`,
                }}
            >
                {/* Header */}
                <div className={styles.cornerCell} />
                {columns.map((col) => (
                    <div key={col} className={styles.headerCell}>{col}</div>
                ))}

                {/* Rows */}
                {rows.map((row) => (
                    <Fragment key={row}>
                        <div className={styles.rowHeader}>{row}</div>
                        {columns.map((col) => {
                            const count = heatmap[row]?.[col] ?? 0;
                            const intensity = maxVal > 0 ? count / maxVal : 0;
                            const pct = totalCount > 0 ? Math.round((count / totalCount) * 100) : 0;
                            return (
                                <div
                                    key={`${row}-${col}`}
                                    className={styles.cell}
                                    style={{ '--intensity': intensity } as React.CSSProperties}
                                    title={`${row} × ${col}: ${count} (${pct}%)`}
                                >
                                    <span className={styles.cellCount}>{count}</span>
                                </div>
                            );
                        })}
                    </Fragment>
                ))}
            </div>
        </div>
    );
}
